import React from "react";
import { X } from "react-feather";

import { ReactComponent as Checked } from "~/assets/images/dashboard/Checked.svg";
import { ReactComponent as Unchecked } from "~/assets/images/dashboard/Unchecked.svg";

import Loader from "~/components/loader"


import { TaskRewardStatusType } from "~/services/tasks";


const CheckMark = ({task})=> {

  return (
    <div className="m-r-20">
      { task.status === TaskRewardStatusType.NEW      && <Unchecked/> }
      { task.status === TaskRewardStatusType.PENDING  && <Loader type={19} size={30} /> }
      { task.status === TaskRewardStatusType.ACCEPTED && <Checked /> }
      { task.status === TaskRewardStatusType.REJECTED && <X className="text-danger" style={{width: 50, height: 50}} /> }
    </div>
  );
}

export default CheckMark;
